import I18n from 'i18n-js';
import React from 'react';

import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { CoreShopContainer } from '../../../schemas/rql';

interface IExternalProps {
  shop: CoreShopContainer.Shop;
}

function FreeShippingCallout({ shop }: IExternalProps) {
  return (
    <div className="shop-headerv2__free-shipping">
      <SanitizedRender
        html={I18n.t('discovery.shopHeader.freeShipping', {
          tagOpen: '<strong>',
          tagClose: '</strong>',
          shopName: shop.name,
          displayAmount: shop.freeDomesticShippingRate.freeShippingThreshold.display })
        }
        htmlTag="span"
        className="shop-headerv2__free-shipping__message"
      />
    </div>
  );
}

export default FreeShippingCallout;
